import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {DateService} from '@services/date.service';

import {Gateway} from '@models/adminstration/gateway/gateway';
import {UPDATE_STATE} from '@models/gateway/update/update-state.constant';
import {UpdateStatus} from '@models/gateway/update/update-status';
import {RebootStatus} from '@models/adminstration/gateway/gateway-reboot-status';
import {ConnectionStatus} from '@models/gateway/connection/connection-status';
import {CONNECTION_STATE} from '@models/gateway/connection/connection-state.constant';

import {REBOOT_STATE} from '@constants/administration/gateway/reboot-state';

@Component({
    selector: 'scitis-admin-gateway-details',
    templateUrl: './gateway-details.component.html',
    styleUrls: ['./gateway-details.component.scss'],
    standalone: false
})
export class GatewayDetailsComponent implements OnInit {

  @Input()
  gateway: Gateway = new Gateway();

  @Input()
  isCPOneGateway: boolean = false;

  @Input()
  isCPEdgeGateway: boolean = false;

  @Input()
  isCPLightGateway: boolean = false;

  @Input()
  isArgosGateway: boolean = false;

  @Input()
  isCPSoftGateway: boolean = false;

  @Input()
  isGenericGateway: boolean = false;

  @Input()
  packages: any[] = [];

  filteredPackages: any[] = [];

  updatePackage: boolean = false;
  searchTerm: string = '';

  constructor(private translate: TranslateService,
              private dateService: DateService) {
  }

  private static getSearchTermValue(event: Event): string {
    if (!event || !event.target) {
      return '';
    } else {
      const element = event.target as HTMLInputElement;
      if (!element || !element.value) {
        return '';
      } else {
        return element.value;
      }
    }
  }

  private static searchTermFoundInProperties(gatewayPackage: any, term: string): boolean {
    return gatewayPackage.name.toLowerCase().includes(term.toLowerCase());
  }

  ngOnInit() {
    this.filteredPackages = this.packages;
  }

  isIotBridgeStreaming(): boolean {
    if (this.isCPOneGateway || this.isCPEdgeGateway) {
      if (this.gateway.iotCore) {
        return true;
      }
    }
    return false;
  }

  shouldDisplayIotCoreDetails(): boolean {
    if (this.isGenericGateway || this.isCPLightGateway || this.isArgosGateway) {
      return !!this.gateway.iotCore;
    } else {
      return this.isIotBridgeStreaming();
    }
  }

  getLastUpdateStatus(status?: UpdateStatus) {
    if (!status || !status.lastUpdate) {
      return '---';
    }
    return this.dateService.getMediumDate(status.lastUpdate);
  }

  getUpdateStatus(status?: UpdateStatus) {
    if (!status || !status.state) {
      return '---';
    }
    if (status.state === UPDATE_STATE.ERROR || status.state === UPDATE_STATE.NONE) {
      return this.translate.instant('Unknown');
    } else if (status.state === UPDATE_STATE.AVAILABLE || status.state === UPDATE_STATE.PENDING || status.state === UPDATE_STATE.PROGRESS) {
      return this.translate.instant('Update available');
    } else if (status.state === UPDATE_STATE.SUCCESS) {
      return this.translate.instant('Success');
    } else {
      return '---';
    }
  }

  getLastConnectionStatus(status: ConnectionStatus) {
    if (!status || !status.lastContact) {
      return '---';
    }
    return this.dateService.getMediumDate(status.lastContact);
  }

  getConnectionStatus(status: ConnectionStatus) {
    if (!status || !status.state) {
      return '---';
    }
    if (status.state === CONNECTION_STATE.UNKNOWN) {
      return this.translate.instant('Unknown');
    } else if (status.state === CONNECTION_STATE.OFFLINE) {
      return this.translate.instant('Offline');
    } else if (status.state === CONNECTION_STATE.ONLINE) {
      return this.translate.instant('Online');
    } else {
      return '---';
    }
  }

  getLastRebootStatus(status?: RebootStatus) {
    if (!status || !status.lastReboot) {
      return '---';
    }
    return this.dateService.getMediumDate(status.lastReboot);
  }

  getRebootStatus(status?: RebootStatus) {
    if (!status || !status.state) {
      return '---';
    }

    switch (status.state) {
      case REBOOT_STATE.ERROR: {
        return this.translate.instant('Error');
      }
      case REBOOT_STATE.PROGRESS: {
        return this.translate.instant('Rebooting');
      }
      case REBOOT_STATE.SUCCESS: {
        return this.translate.instant('Success');
      }
      default: {
        return '---';
      }
    }
  }

  changeStatus(event: any) {
    if (event.target.checked) {
      this.filteredPackages = this.packages.filter(gatewayPackage => {
        return gatewayPackage.updatable;
      });
    } else {
      this.filteredPackages = this.packages;
    }
  }

  onSearchPackages(event: Event) {
    this.searchTerm = GatewayDetailsComponent.getSearchTermValue(event);
    this.filteredPackages = this.packages.filter(gatewayPackage => GatewayDetailsComponent.searchTermFoundInProperties(gatewayPackage, this.searchTerm));
  }

}
